import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, apiErr } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight, Loader2, Lock } from "lucide-react";
import BrandMark, { LogoFull } from "@/components/BrandMark";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    if (password.length < 8) return toast.error("Parola trebuie să aibă minim 8 caractere");
    if (password !== confirm) return toast.error("Parolele nu coincid");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Parola a fost resetată. Autentifică-te.");
      navigate("/login");
    } catch (e) {
      toast.error(apiErr(e));
    } finally {
      setBusy(false);
    }
  }

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ink-soft p-6">
        <div className="bg-white border border-neutral-200 p-10 max-w-md w-full text-center">
          <h1 className="font-display font-black text-2xl">Link invalid</h1>
          <p className="mt-3 text-ink-muted text-sm">Solicită un link nou de resetare a parolei.</p>
          <Link to="/forgot-password" className="mt-6 inline-flex btn-brand">Cere link nou</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-ink-soft p-6">
      <div className="w-full max-w-md bg-white border border-neutral-200 p-10">
        <div>
          <LogoFull variant="dark" size="md" />
        </div>
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-brand mt-8 mb-2">— Setează parolă nouă</div>
        <h1 className="font-display font-black text-3xl md:text-4xl tracking-tight">Parolă nouă</h1>
        <p className="mt-3 text-ink-muted text-sm">Minim 8 caractere.</p>
        <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="reset-form">
          <div>
            <label className="font-mono text-[11px] uppercase tracking-widest text-ink-muted">Parolă nouă</label>
            <div className="relative mt-2">
              <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-ink-muted" />
              <input
                data-testid="reset-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-11 pr-4 py-3.5 border border-neutral-200 focus:border-brand focus:outline-none"
              />
            </div>
          </div>
          <div>
            <label className="font-mono text-[11px] uppercase tracking-widest text-ink-muted">Confirmă parola</label>
            <div className="relative mt-2">
              <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-ink-muted" />
              <input
                data-testid="reset-confirm"
                type="password"
                required
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                className="w-full pl-11 pr-4 py-3.5 border border-neutral-200 focus:border-brand focus:outline-none"
              />
            </div>
          </div>
          <button data-testid="reset-submit" disabled={busy} className="w-full btn-brand justify-center disabled:opacity-70">
            {busy ? <><Loader2 className="h-4 w-4 animate-spin" /> Se resetează</> : <>Resetează parola <ArrowRight className="h-4 w-4" /></>}
          </button>
        </form>
      </div>
    </div>
  );
}
